import * as React from "react";
import { AbstractReactFactory } from "@projectstorm/react-canvas-core";
import SolutionFlowNodeModel from "./SolutionFlowNodeModel";
import SolutionFlowNodeWidget from "./SolutionFlowNodeWidget";

export default class SolutionFlowNodeFactory extends AbstractReactFactory {
  constructor(onNodeClick) {
    super("solution-flow-node");
    this.onNodeClick = onNodeClick;
  }

  generateModel(data) {
    return new SolutionFlowNodeModel(data);
  }

  generateReactWidget(event) {
    return (
      <SolutionFlowNodeWidget
        engine={this.engine}
        node={event.model}
        onNodeClick={this.onNodeClick}
      />
    );
  }
}
